import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import VueDraggable from 'vuedraggable';
import { ImageEffectType, isTextToImageEffect } from '@/typings/customilyElements/imageEffectType';
import ImageEffectsPropertiesListItem from '@/components/DesignStudio/ImageEffectsProperties/components/list/item/ImageEffectsPropertiesListItem.vue';

interface Emits {
    (event: 'update', effect: ImageEffectType): void;
    (event: 'remove', effect: ImageEffectType): void;
    (event: 'reorder', effects: ImageEffectType[]): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesList',
  props: {
    items: null,
    disabled: { type: Boolean }
  },
  emits: ["update", "remove", "reorder"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update', effect: ImageEffectType): void;
    (event: 'remove', effect: ImageEffectType): void;
    (event: 'reorder', effects: ImageEffectType[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    items: ImageEffectType[];
    disabled?: boolean;
};





const pinnedItem = computed(() =>
    props.items.length && isTextToImageEffect(props.items[0].type) ? props.items[0] : null
);

const sortable = reactive({ items: [] as ImageEffectType[] });

watch(
    () => props.items,
    (items) => {
        const hasPinned = items.length > 0 && isTextToImageEffect(items[0].type);
        sortable.items = hasPinned ? items.slice(1) : [...items];
    },
    { deep: true, immediate: true }
);

const handleUpdate = (imageEffect: ImageEffectType) => {
    emit('update', imageEffect);
};

const handleRemove = (imageEffect: ImageEffectType) => {
    emit('remove', imageEffect);
};

const handleReorder = () => {
    const reordered = pinnedItem.value ? [pinnedItem.value, ...sortable.items] : sortable.items;
    emit('reorder', reordered);
};

return { __sfc: true,props, emit, pinnedItem, sortable, handleUpdate, handleRemove, handleReorder, VueDraggable, ImageEffectsPropertiesListItem }
}

})